import * as api from "./middleware/api.middleware";
import { requireActiveEnvironmentId } from "./environment.store";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "environments";
const getAccessToken = () => getAuthHeader();

const getEnvironmentId = () => requireActiveEnvironmentId();

export function getDataLinage(dataSourceId: number) {
  const getResponse = api.get<any>(
    `environment/${getEnvironmentId()}/data_lineage_upstream/${dataSourceId}`,
    getAccessToken()
  );
  return getResponse;
}

export function getDataSources() {
  const getResponse = api.get<any>(
    `${serviceUrl}/${getEnvironmentId()}/data_sources`,
    getAccessToken()
  );
  return getResponse;
}

export function getDataMarts() {
  const getResponse = api.get<any>(
    `environment/${getEnvironmentId()}/data_marts`,
    getAccessToken()
  );
  return getResponse;
}

export function createDataMart(dataMart: string) {
  const getResponse = api.post<any>(
    `environment/${getEnvironmentId()}/data_mart`,
    { data_mart: dataMart },
    getAccessToken()
  );
  return getResponse;
}

export function getDownstreamData(dataMartId: number) {
  const getResponse = api.get<any>(
    `environment/${getEnvironmentId()}/data_lineage_downstream?data_mart_id=${dataMartId}`,
    getAccessToken()
  );
  return getResponse;
}
